import { Bot, Brain, MessageCircle, Settings2, Sliders, UserRound } from "lucide-react";
import { useMemo, useState } from "react";
import { useAppData } from "./hooks/useAppData";
import { ApiSettingsPage } from "./pages/ApiSettingsPage";
import { CharacterPage } from "./pages/CharacterPage";
import { ConversationPage } from "./pages/ConversationPage";
import { MemoryPage } from "./pages/MemoryPage";
import { SetupPage } from "./pages/SetupPage";
import { VoicePage } from "./pages/VoicePage";

type Tab = "conversation" | "memory" | "voice" | "character" | "api";

export function App() {
  const data = useAppData();
  const [tab, setTab] = useState<Tab>("conversation");
  const needsSetup = useMemo(() => data.settings && !data.settings.userName, [data.settings]);

  if (!data.settings) return <main className="screen"><p>読み込み中...</p></main>;
  if (needsSetup) return <SetupPage settings={data.settings} onSave={data.updateSettings} onMedia={data.saveMedia} />;

  return (
    <div className="app-shell">
      {data.error ? <div className="toast" role="alert">{data.error}<button type="button" onClick={() => data.setError("")}>閉じる</button></div> : null}
      {tab === "conversation" ? (
        <ConversationPage
          settings={data.settings}
          memories={data.memories}
          messages={data.messages}
          media={data.activeCharacterMedia}
          voiceProfile={data.activeVoiceProfile}
          onSettings={data.updateSettings}
          onRefresh={data.refresh}
          onError={data.setError}
          openSettings={() => setTab("api")}
        />
      ) : null}
      {tab === "memory" ? <MemoryPage memories={data.memories} onSave={data.saveMemory} onDelete={data.removeMemory} onRefresh={data.refresh} onError={data.setError} /> : null}
      {tab === "voice" ? <VoicePage settings={data.settings} profiles={data.voiceProfiles} media={data.media} active={data.activeVoiceProfile} onSettings={data.updateSettings} onSaveProfile={data.saveVoiceProfile} onSaveMedia={data.saveMedia} onError={data.setError} /> : null}
      {tab === "character" ? <CharacterPage settings={data.settings} media={data.media} onSettings={data.updateSettings} onMedia={data.saveMedia} onError={data.setError} /> : null}
      {tab === "api" ? <ApiSettingsPage settings={data.settings} storage={data.storage} onSettings={data.updateSettings} onRefresh={data.refresh} /> : null}
      <nav className="bottom-nav" aria-label="メイン">
        <button data-testid="tab-conversation" className={tab === "conversation" ? "active" : ""} type="button" onClick={() => setTab("conversation")}><MessageCircle />会話</button>
        <button data-testid="tab-memory" className={tab === "memory" ? "active" : ""} type="button" onClick={() => setTab("memory")}><Brain />記憶</button>
        <button data-testid="tab-voice" className={tab === "voice" ? "active" : ""} type="button" onClick={() => setTab("voice")}><Sliders />音声</button>
        <button data-testid="tab-character" className={tab === "character" ? "active" : ""} type="button" onClick={() => setTab("character")}><UserRound />キャラ</button>
        <button data-testid="tab-api" className={tab === "api" ? "active" : ""} type="button" onClick={() => setTab("api")}><Settings2 />API</button>
      </nav>
      <span className="sr-only"><Bot /> AIとの会話アプリ</span>
    </div>
  );
}
